import { render, staticRenderFns } from "./Popin.vue?vue&type=template&id=52d7e6dc&scoped=true&"
import script from "./Popin.vue?vue&type=script&lang=ts&"
export * from "./Popin.vue?vue&type=script&lang=ts&"
import style0 from "./Popin.vue?vue&type=style&index=0&id=52d7e6dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d7e6dc",
  null
  
)

export default component.exports